export const StaffViewsEnum = {
    staffReport: 0,
    staffHistory: 1,
}